<template>
  <b-modal
    ref="confirmEntitlementsClear"
    centered
    size="md"
    title="Wait! Are you sure?"
    header-text-variant="danger"
    footer-bg-variant=""
    hide-header
    scrollable>

    <b-alert
      variant="light-danger"
      show
      class="mb-0">
      <p class="font-size-lg mb-0">
        When clearing all entitlement rules, it will lead to the cancellation and application of standard rules for all existing users that were previously applied according to the current rules (for example, 1 device per user). Are you sure you want to perform this action?
      </p>
    </b-alert>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('confirmEntitlementsClear')">
          Cancel
        </b-button>
        <b-button
          variant="danger"
          size="md"
          class="ml-auto"
          :disabled="revenuecatResponses('clearEntitlements')"
          @click="clearEntitlements(), hideModal('confirmEntitlementsClear')">
          Yes, clear them all
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  CLEAR_ALL_ENTITLEMENTS,
  GET_ENTITLEMENTS
} from '@/core/services/store/reseller_revenuecat.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'

export default {
  name: 'ModalClearEntitlements',
  data() {
    return {
      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'integrationsList',
      'failedGetResellerStatus',
      'failedIntegrationGetStatus',
      'revenuecatApikey',
      'revenuecatApikeyEmpty',
      'revenuecatPubkey',
      'revenuecatPubkeyEmpty',
      'entitlementsList',
      'entitlementsListLength',
      'entitlementsListEmpty',
      'selectedEntitlement',
      'selectedEntitlementId',
      'noEmptyEntitlementFields',
      'isNewEntitlementField',
      'manageEntitlementErrors',
      'entitlementFieldInvalidState',
      'revenuecatResponses'
    ]),

    routeId() {
      return this.$route.params.id
    },
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    clearEntitlements() {
      this.$store
        .dispatch(CLEAR_ALL_ENTITLEMENTS, { id: this.routeId })
        .then(() => {
          this.$store.dispatch(GET_ENTITLEMENTS, { id: this.routeId })
        })
    }
  }
}
</script>
